import { lazyWithRetry } from 'src/react-app/utilits/lazy-with-retry'

export const ModalCancelAsync = lazyWithRetry(() => import('./modal-cancel'))
